import searcherConfig from '@/modules/searcher/config';

export const getDefaultSearcherContentTypesForSite = (siteAlias) => {
  const siteDefault = searcherConfig.defaultSearcherContenTypesBySite[siteAlias];
  if (Array.isArray(siteDefault)
    && siteDefault.length > 0
  ) {
    return siteDefault;
  }
  return searcherConfig.defaultSearcherContentTypes;
};

export default getDefaultSearcherContentTypesForSite;
